<template>
  <AppContainer max-width="max-w-3xl">
    <form
      autocomplete="off"
      @submit.prevent="submitForm"
    >
      <AppCard>
        <div>
          <div>
            <AppGrid
              cols="2"
            >
              <AppGridItem>
                <TextInput
                  v-model.trim="formData.name"
                  label="Name"
                  :class="{ 'input-error': hasValidationError('name') }"
                  :validation-error="getValidationError('name') || null"
                />
              </AppGridItem>

              <AppGridItem>
                <TextInput
                  v-model.trim="formData.powerBiRegionLookupValue"
                  label="PowerBi Region Lookup Value"
                  :class="{ 'input-error': hasValidationError('powerBiRegionLookupValue') }"
                  :validation-error="getValidationError('powerBiRegionLookupValue') || null"
                />
              </AppGridItem>

              <AppGridItem
                col-span="2"
                class="input-field"
              >
                <label>Province</label>

                <SelectInput
                  v-model="formData.province"
                  required
                  nullable
                  :options="provinceOptions"
                />

                <span
                  v-if="hasValidationError('province')"
                  class="text-red-500"
                >
                  {{ getValidationError('province') }}
                </span>
              </AppGridItem>
            </AppGrid>
          </div>
        </div>
        <template #buttons>
          <ButtonSubmitRow
            :processing="isSubmitting"
            :cancel-route="{ name: 'app_district_list' }"
          />
        </template>
      </AppCard>
    </form>
  </AppContainer>
</template>

<script setup>
import { computed, reactive } from 'vue';

import { AppContainer, AppGrid, AppGridItem } from '@/components/app';
import { AppCard } from '@/components/cards';
import { ButtonSubmitRow } from '@/components/buttons';
import { SelectInput, TextInput } from '@/components/form-inputs';

import { useFormSubmit } from '@/composables';

const props = defineProps({
  model: {
    type: Object,
    default: () => null,
  },
  provinces: {
    type: Array,
    default: () => [],
  },
});

const { isSubmitting, submit, hasValidationError, getValidationError } = useFormSubmit();

const formData = reactive({
  name: props.model?.name || null,
  province: props.model?.province?.id || null,
  powerBiRegionLookupValue: props.model?.powerBiRegionLookupValue || null,
});

const provinceOptions = computed(() => {
  return props.provinces?.map(province => ({
    label: province.name,
    value: province.id,
  }));
});

const submitForm = async () => {
  await submit(props.model?.id, formData, 'app_district_list', 'districts');
};

</script>
